module.exports = __webpack_public_path__ + "img/icon-account-password@3x.af538914.png";